import { createContext, useContext } from "react";

export interface MetaData {
  title: string;
  description: string;
  ogImage: string;
  url: string;
  type: string;
  articlePublishedTime?: string;
  robots?: string;
}

/**
 * During SSR, this context collects meta tag data so the prerender script
 * can inject it into the HTML <head>. On the client it stays null and
 * useMetaTags falls back to the useEffect-based DOM manipulation.
 */
export const MetaContext = createContext<{ set: (meta: MetaData) => void } | null>(null);

export function useMetaContext() {
  return useContext(MetaContext);
}
